const DISMISSED_KEY = "scanbrix_crm_notif_dismissed_v1";

function dueMs(task) {
  const d = task?.dueAt;
  if (!d) return null;
  if (d?.toMillis) return d.toMillis();
  if (d instanceof Date) return d.getTime();
  const t = new Date(d).getTime();
  return Number.isNaN(t) ? null : t;
}

export function loadDismissedIds() {
  try {
    return new Set(JSON.parse(localStorage.getItem(DISMISSED_KEY) || "[]"));
  } catch {
    return new Set();
  }
}

export function dismissNotification(id) {
  const s = loadDismissedIds();
  s.add(id);
  localStorage.setItem(DISMISSED_KEY, JSON.stringify([...s]));
}

export function buildTaskNotifications(tasks, userEmail, now = Date.now()) {
  const dismissed = loadDismissedIds();
  const out = [];
  const email = (userEmail || "").toLowerCase();
  for (const t of tasks || []) {
    if (t.status !== "open") continue;
    const owner = (t.owner || t.assignee || "").toLowerCase();
    if (owner && email && owner !== email && !owner.includes(email.split("@")[0])) continue;
    const due = dueMs(t);
    if (!due) continue;
    const overdue = due < now;
    const dueToday = new Date(due).toDateString() === new Date(now).toDateString();
    const soon = due - now < 24 * 60 * 60 * 1000 && due >= now;
    if (!overdue && !dueToday && !soon) continue;
    const nid = `${t.id}_${overdue ? "overdue" : dueToday ? "due" : "soon"}`;
    if (dismissed.has(nid)) continue;
    out.push({
      id: nid,
      taskId: t.id,
      title: t.title,
      label: overdue ? "Overdue" : dueToday ? "Due today" : "Due within 24h",
      dueAt: due,
    });
  }
  return out.sort((a, b) => a.dueAt - b.dueAt);
}
